import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyVariable } from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import { DialogSaveButton } from '../../common/Global/globalStyles.style';
import { DatePicker } from 'antd';
import moment from 'moment';

let userDetails = getLocalStorageVariables();

class AddFrameworkRepealed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            repealedDate:"",
            formErrors:{},
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showRepealedDialog){
            this.setState({
                repealedDate:"",
                formErrors:{}
            })
        }
    }

    // Updates the repealedDate state and resets form errors when the date changes.
    onRepealedDateChange = (date, dateString) => {
        let repealedDate = "";
        if (!isEmptyVariable(date)) {
            repealedDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['repealedDate'] = "";

        this.setState({
            repealedDate:repealedDate,
            formErrors:FormErrorsTemp
        })
    }

    /*******************API CALLS*******************/
    handleAddRepealed = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};
        
        if(isEmptyVariable(this.state.repealedDate)){
            isError = true;
            FormErrorsTemp['repealedDate'] = "Please select repealed date";
        }

        if(isError){
            this.setState({
                formErrors: FormErrorsTemp,
                showLoader: false,
            });
        }else{
            fetch(Constants.AddFrameworkRepealed,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    repealedDate:this.state.repealedDate,
                    frameworkId:this.props.frameworkId
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            showLoader:false,
                            formErrors:{},
                        },() => {
                            this.props.handleRepealedDialogClose(true);
                        });
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage,
                        showLoader:false
                    });
                }
            });
        }
    }
    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <>
                <Modal className="custom-dialog" show={this.props.showRepealedDialog} onHide={this.props.handleRepealedDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>{"Add Framework Repealed"}</h5>
                        <button 
                            onClick={this.props.handleRepealedDialogClose}
                            type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="addnew-modal-form">
                            <div className="addnew-modal-form-group">
                                <p>Repealed Date*</p>
                                <DatePicker
                                    onChange={this.onRepealedDateChange}
                                    format={"DD/MM/YYYY"}
                                    value={!isEmptyVariable(this.state.repealedDate) ? moment(this.state.repealedDate) : ""}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['repealedDate']) &&
                                    <span className="cm-error">{this.state.formErrors['repealedDate']}</span>
                                }
                            </div>
                            <div className="modal-close-save">
                                <div className="close-save-col">
                                    <button onClick={this.props.handleRepealedDialogClose} type="button" className="modal-close">Cancel</button>
                                    <DialogSaveButton
                                    themeSettings={this.props.themeSettings}
                                    onClick={this.handleAddRepealed} type="button">
                                        Save
                                    </DialogSaveButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
export default AddFrameworkRepealed;